const CONSENT_KEY = 'bd_eventlocation_cookie_consent';
const GOOGLE_ADS_ID = 'AW-18054291996';
const LEAD_CONVERSION_ID = 'AW-18054291996/pLSACIagiqAcEJzE-qBD';
const AI_FUNNEL_LEAD_CONVERSION_ID = 'AW-18054291996/_kx2COa2wLEcEJzE-qBD';
const WHATSAPP_CONVERSION_ID = 'AW-18054291996/nhgDCLv9jaAcEJzE-qBD';
const POSTHOG_KEY = 'phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs';
const POSTHOG_HOST = 'https://us.i.posthog.com';

export const getConsentState = () => {
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed && parsed.decisionMade === true && typeof parsed.necessary === 'boolean') {
        return parsed;
      }
    }
  } catch (e) { /* corrupt state = no consent */ }
  return null;
};

export const setConsentState = (state) => {
  const consent = {
    necessary: true,
    analytics: !!state.analytics,
    marketing: !!state.marketing,
    decisionMade: true,
    timestamp: new Date().toISOString()
  };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));

  window.__marketingConsentGranted = consent.marketing;
  window.__analyticsConsentGranted = consent.analytics;

  if (window.gtag) {
    window.gtag('consent', 'update', {
      analytics_storage: consent.analytics ? 'granted' : 'denied',
      ad_storage: consent.marketing ? 'granted' : 'denied',
      ad_user_data: consent.marketing ? 'granted' : 'denied',
      ad_personalization: consent.marketing ? 'granted' : 'denied',
    });
  }

  if (consent.marketing) {
    loadGoogleAdsTag();
  }

  if (consent.analytics) {
    loadPostHog();
  }

  window.dispatchEvent(new CustomEvent('consentChanged', { detail: consent }));
  return consent;
};

export const initConsent = () => {
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;

  gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    wait_for_update: 500,
  });

  window.__marketingConsentGranted = false;
  window.__analyticsConsentGranted = false;

  const stored = getConsentState();
  if (stored && stored.decisionMade) {
    window.__marketingConsentGranted = stored.marketing === true;
    window.__analyticsConsentGranted = stored.analytics === true;

    if (stored.marketing) {
      gtag('consent', 'update', {
        analytics_storage: stored.analytics ? 'granted' : 'denied',
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
      });
      loadGoogleAdsTag();
    }

    if (stored.analytics) {
      loadPostHog();
    }
  }
};

export const loadGoogleAdsTag = () => {
  if (document.getElementById('google-ads-script')) return;

  const script = document.createElement('script');
  script.id = 'google-ads-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
  document.head.appendChild(script);

  script.onload = () => {
    if (window.gtag) {
      window.gtag('js', new Date());
      window.gtag('config', GOOGLE_ADS_ID);
    }
  };
};

export const loadPostHog = () => {
  if (document.getElementById('posthog-script') || window.posthog?.__loaded) return;

  const script = document.createElement('script');
  script.id = 'posthog-script';
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.src = `${POSTHOG_HOST.replace('.i.posthog.com', '-assets.i.posthog.com')}/static/array.js`;
  document.head.appendChild(script);

  script.onload = () => {
    if (window.posthog && window.posthog.init) {
      window.posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        person_profiles: 'identified_only',
        session_recording: { recordCrossOriginIframes: true },
        loaded: (ph) => { ph.__loaded = true; }
      });
    }
  };
};

// Google Ads Lead-Formular Conversions — fired only after successful backend save + email
export const trackLeadFormConversion = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'lead_form_submit_success' });

  if (!window.gtag || !window.__marketingConsentGranted) return;

  // Original lead conversion
  window.gtag('event', 'conversion', {
    send_to: LEAD_CONVERSION_ID
  });

  // AI Funnel lead conversion (AW-18054291996/_kx2COa2wLEcEJzE-qBD)
  window.gtag('event', 'conversion', {
    send_to: AI_FUNNEL_LEAD_CONVERSION_ID,
    value: 1.0,
    currency: 'EUR'
  });
};

export const trackWhatsAppConversion = (url) => {
  if (!window.gtag || !window.__marketingConsentGranted) {
    if (url) window.open(url, '_blank');
    return;
  }

  let called = false;
  const callback = () => {
    if (called) return;
    called = true;
    if (url) window.open(url, '_blank');
  };

  window.gtag('event', 'conversion', {
    send_to: WHATSAPP_CONVERSION_ID,
    event_callback: callback
  });

  setTimeout(callback, 1200);
};
